export const HIRING_OUTCOME_SURVEY_ID = "019d2132-586b-0000-ea05-23d1fa577dd4";

const HIRING_OUTCOME_HIRED_QUESTION_ID = "6b21d28c-2d1a-4ded-8b94-966a04181544";

export const HIRING_OUTCOME_COMPLETED_AT_PROPERTY =
  "hiring_outcome_completed_at";

const HIRING_OUTCOME_SURVEY_SEEN_KEY = "nimble:hiring_outcome_survey_seen";

export const isHiringOutcomeYesResponse = (
  properties: Record<string, unknown> | undefined,
): boolean => {
  if (!properties) return false;
  const response =
    properties[`$survey_response_${HIRING_OUTCOME_HIRED_QUESTION_ID}`];
  return typeof response === "string" && response.startsWith("Yes");
};

// sessionStorage can be undefined (SSR) or throw on access (private-mode browsers).
const trySession = <T>(read: (s: Storage) => T, fallback: T): T => {
  if (typeof window === "undefined") return fallback;
  try {
    return read(window.sessionStorage);
  } catch {
    return fallback;
  }
};

export const markHiringOutcomeSurveySeen = () =>
  trySession(
    (session) => session.setItem(HIRING_OUTCOME_SURVEY_SEEN_KEY, "true"),
    undefined,
  );

export const wasHiringOutcomeSurveySeen = (): boolean =>
  trySession(
    (session) => session.getItem(HIRING_OUTCOME_SURVEY_SEEN_KEY) !== null,
    false,
  );

export const clearHiringOutcomeSurveySeen = () =>
  trySession(
    (session) => session.removeItem(HIRING_OUTCOME_SURVEY_SEEN_KEY),
    undefined,
  );
